// extracted by mini-css-extract-plugin
export default {"phoneButton":"components-ContactInfo-themes-PP-styles__phoneButton--stguc","phoneIcon":"components-ContactInfo-themes-PP-styles__phoneIcon--r4JpH"};